import type { dateRangeType } from '../../components/CustomDateRangePicker/types';

export enum careLogType {
  login = 'login',
  measurement = 'measurement',
  walk = 'walk',
  surgery = 'surgery',
  questionnaire = 'questionnaire',
  deviceAdjustment = 'deviceAdjustment',
  fall = 'fall',
  injury = 'injury',
  changeTherapist = 'changeTherapist',
}

export interface ITagsDetails {
  levelOfAssistance?: number | number[];
  assistiveDevice?: number | number[];
  tags?: string[];
  medicalDevices?: string[];
  note?: string;
  useOfHands?: boolean | null;
}

export enum resultStateEnum {
  no_result = 0,
  minimal = 1,
  partial = 2,
  full = 3,
}
export interface IMeasurementLog {
  displayName: string;
  shortName: string;
  mainParam: number;
  mainParamName: string;
  mainParamKey: string;
  units: string;
  activityName: string;
  detectedSide?: string;
  perceptionParams: ITagsDetails;
  resultState: resultStateEnum;
  isMainParamSelfReported?: boolean;
}

export interface IQuestionnaireLog {
  displayName: string;
  score: number;
  maxScore: number;
}

interface IEventLog {
  name?: string;
  affectedSide: number;
  description?: string;
}

export interface IWalkLog {
  walkScore: number;
  steps: number;
  duration: number;
  detectedSide?: string;
  activityName: string;
  perceptionParams: ITagsDetails;
  resultState: resultStateEnum;
}

interface IAdjustmentLog {
  medicalDevice: string;
  description: string;
}

interface IFallLog {
  description: string;
  witnessed: string;
  location: string;
}

interface ITherapistLog {
  ptName: string;
  oldPtName: string;
}

export interface ICareLog {
  uuid: string;
  logDatetime: string;
  logDate: string;
  type: careLogType;
  measurement?: IMeasurementLog;
  walk?: IWalkLog;
  surgery?: IEventLog;
  questionnaire?: IQuestionnaireLog;
  deviceAdjustment?: IAdjustmentLog;
  fall?: IFallLog;
  changedPt?: ITherapistLog;
  injury?: IEventLog;
}

export type CareLogDateFilterType = {
  fromDate: dateRangeType;
  toDate: dateRangeType;
  type?: string;
};

export type CareLogFiltersType = string[] | CareLogDateFilterType;

export interface ICareLogStore {
  filters: { [id: string]: CareLogFiltersType };
  setFilter(key: string, value: CareLogFiltersType): void;
  clearFilters(): void;
}

export interface ICareLogService {
  careLogs: ICareLog[];
  isLoading: boolean;
  firstLogin: string;
  state: ICareLogStore;
  isError: boolean;
  error: Error | null;
  dismissCareLog: (uuid: string) => void;
}

export enum careLogFilterType {
  date = 'time',
  activity = 'activity',
  tag = 'tag',
}
